 
import React from "react";
import logo from './../../../assets/img/logo.png'

import "./../../../styles/HeaderComponent.scss";

// Logo function
// Shows app logo
export default function Logo(login) {
    return ( 
        <div className="Logo">
            <a href={window.location.pathname === '/Login' || window.location.pathname === '/Register' ? '/' : "#"}>
                <img src={logo} style={ login ? {maxWidth:'120px'} : { maxWidth:'120px', height: '49px' , width: '120px' } } alt="Logo" />
            </a>
        </div>
    );
}